import React, { useState } from 'react';
import ToggleExpandBtn from '../ToggleExpandBtn/ToggleExpandBtn';
import styles from './ShutdownDesc.module.scss';

const maxSize = 100;

const DescWithToggle = ({ description }) => {
  const [showAll, setShowAll] = useState(false);

  const desc = showAll ? description : `${description.slice(0, maxSize)}...`;

  return (
    <div className={styles.root}>
      <span>{desc}</span>
      <ToggleExpandBtn
        onClick={() => setShowAll((prev) => !prev)}
        text={showAll ? 'Скрыть' : `Показать все`}
      />
    </div>
  );
};

const Description = ({ description }) =>
  description.length <= maxSize ? (
    description
  ) : (
    <DescWithToggle description={description} />
  );

const ShutdownDesc = ({ description }) => {
  const desc = description?.trim();
  return desc ? <Description description={desc} /> : 'Не указано';
};

export default ShutdownDesc;
